import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import styled from 'styled-components';
import '../../node_modules/styled-system/dist/index.esm.js';
import { Paragraph } from '../typography/Paragraph.js';
import { space } from '../../node_modules/@styled-system/space/dist/index.esm.js';
var Label = styled(Paragraph)(function (_a) {
  var isFocused = _a.isFocused,
    hasValue = _a.hasValue,
    isDisabled = _a.isDisabled,
    isInvalid = _a.isInvalid;
  var color = "grey.1";
  if (isDisabled) {
    color = "grey.2";
  }
  if (isInvalid) {
    color = "red.300";
  }
  return css({
    lineHeight: "1",
    transform: isFocused || hasValue ? "scale(.75)" : "translateY(75%)",
    transformOrigin: "left center",
    transition: "all 0.3s",
    userSelect: "none",
    margin: 0,
    marginTop: "-2px",
    padding: 0,
    color: color
  });
}, space);
export { Label };